<template>
  <van-list
    v-model="loading"
    finished-text="没有更多了"
    :finished="finished"
    :immediate-check="true"
    @load="onLoad"
  >
    <race-panel v-for="(item, index) in list" :key="index" :race="item" />
  </van-list>
</template>

<script>
import { Icon, Tab, List } from 'vant'
import RacePanel from './RacePanel'
import { raceList } from '@/api/race'

export default {
  name: 'RaceTab',
  components: {
    [Icon.name]: Icon,
    [Tab.name]: Tab,
    [List.name]: List,
    RacePanel
  },
  props: {
  },
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      listQuery: {
        page: 0,
        size: 8
      }
    }
  },
  created () {
  },
  methods: {
    async getList () {
      this.loading = true
      let response = await raceList(this.listQuery)
      this.loading = false
      this.pullLoading = false
      this.list = this.list.concat(response.data.results)
      this.checkFinished(response.data.count)
    },
    onLoad () {
      this.listQuery.page += 1
      this.getList()
    },
    checkFinished (total) {
      this.finished = this.list.length >= total
    }
  }
}
</script>

<style scoped lang="scss">
</style>
